import { render, staticRenderFns } from "./ClassFilter.vue?vue&type=template&id=e87c5a52&scoped=true"
import script from "./ClassFilter.vue?vue&type=script&lang=js"
export * from "./ClassFilter.vue?vue&type=script&lang=js"
import style1 from "./ClassFilter.vue?vue&type=style&index=1&id=e87c5a52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87c5a52",
  null
  
)

export default component.exports